import { useLayoutEffect, useRef, useState } from "react";

import type { RotuloObraProps } from "./types-rotulo-obra";

/**
 * Mostra o nome enquanto ele cabe e a sigla quando não cabe. A largura do nome vem do elemento que o carrega invisível
 * (ele dimensiona o rótulo); a disponível, da largura que o layout deixa ao rótulo. O `ResizeObserver` refaz a conta.
 */
export function useRotuloObra({ nome, sigla }: Pick<RotuloObraProps, "nome" | "sigla">) {
  const [raiz, setRaiz] = useState<HTMLElement | null>(null);
  const medida = useRef<HTMLElement | null>(null);
  const [cabeNome, setCabeNome] = useState(true);

  useLayoutEffect(() => {
    if (!raiz) return;
    let ativo = true;
    const medir = () => setCabeNome((medida.current?.scrollWidth ?? 0) <= raiz.clientWidth);
    medir();
    // A fonte do rótulo carrega tarde e muda a largura do nome: mede de novo quando ela chega.
    void document.fonts?.ready.then(() => {
      if (ativo) medir();
    });
    if (typeof ResizeObserver === "undefined") {
      return () => {
        ativo = false;
      };
    }
    const observer = new ResizeObserver(medir);
    observer.observe(raiz);
    return () => {
      ativo = false;
      observer.disconnect();
    };
  }, [raiz, nome]);

  return {
    texto: cabeNome ? nome : sigla,
    registrarRaiz: setRaiz,
    medidaRef: (elemento: HTMLElement | null) => {
      medida.current = elemento;
    },
  };
}
